import { Fragment } from "react";
import { splitWords } from "@/lib/motion/split.mjs";

// Título T1: cada palabra sube desde una máscara, en cascada. Sigue siendo
// texto real (SEO, lectores de pantalla). `immediate` lo anima al cargar sin
// esperar al vigilante (cabeceras de página).
export default function RevealTitle({ as: Tag = "h2", className = "", immediate = false, children, ...rest }) {
  const words = typeof children === "string" || typeof children === "number" ? splitWords(children) : [];
  if (!words.length) return <Tag className={className} {...rest}>{children}</Tag>;
  return (
    <Tag className={className} data-reveal="title" {...(immediate ? { "data-shown": "" } : {})} {...rest}>
      {words.map(({ word, i }, k) => (
        <Fragment key={k}>
          <span className="mv-mask"><span className="mv-word" style={{ "--i": i }}>{word}</span></span>
          {k < words.length - 1 ? " " : null}
        </Fragment>
      ))}
    </Tag>
  );
}
